import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core'
import { MakeCallIcon, StartConversationIcon, SendFaxIcon, AddContactTopIcon } from 'pdc-svg-icons'
import PropTypes from 'prop-types'
import styles from './styles'

const useStyles = makeStyles(styles)

type AppName = 'calls' | 'faxes' | 'messages' | 'contact'

interface Props {
    app: AppName
    title: string
    onClick: () => void
    disabled?: boolean
    className?: string
    icon?: JSX.Element
    rightIcon?: boolean
    spaceBetween?:boolean
    hideIcon?:boolean
}

/***/
const StartNewButton = (props: Props): JSX.Element => {
    const classes = useStyles()
    const [hovered, setHovered] = useState(false)

    let Icon = MakeCallIcon
    let dataTestId = 'start-conversation'

    switch (props.app) {
            case 'calls':
                Icon = MakeCallIcon
                dataTestId = 'make-call'
                break
            case 'messages':
                Icon = StartConversationIcon
                dataTestId = 'start-conversation'
                break
            case 'faxes':
                Icon = SendFaxIcon
                dataTestId = 'send-fax'
                break
            case 'contact':
                Icon = AddContactTopIcon
                dataTestId = 'contact'
                break
    }

    const icon = (
        <div className={classes.iconContainer}>
            {props.icon || (
                <Icon
                    className={classes.startNewIcon}
                    hover={hovered ? 1 : 0}
                    size={32}
                    isDisabled={props.disabled}
                />
            )}
        </div>
    )

    return (
        <button
            className={`${classes.startNewButton} ${props.className || ''}`}
            onClick={props.onClick}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            data-test-id={dataTestId}
            disabled={props.disabled}
        >
            <div
                className={classes.content}
                style={{
                    flexDirection: props.rightIcon ? 'row-reverse' : 'row',
                    justifyContent: props.spaceBetween
                        ? 'space-between'
                        : 'flex-start'
                }}
            >
                {props.hideIcon ? '' : icon}
                <span>{props.title}</span>
            </div>
        </button>
    )
}

StartNewButton.propTypes = {
    app: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    rightIcon: PropTypes.bool,
    spaceBetween: PropTypes.bool,
    hideIcon: PropTypes.bool
}

export default StartNewButton
